import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";

class ProfileService extends IdentityService {
    public getUserInfo = async () => {
        const result = await this.api.get({
            path: `${Constants.ApiPath.PROFILE.USER_INFO}`,
        });
        return result.data.result;
    };

    public getUserAuthorization = async (organizationId?: string) => {
        const result = await this.api.get({
            path: Constants.ApiPath.PROFILE.USER_AUTHORIZATION,
            query: Helpers.isNullOrEmpty(organizationId) ? undefined : { organizationId: organizationId },
        });
        return result.data.result;
    };

    public updateProfile = async (data: {
        email?: string,
        gender?: number,
        fullName?: string,
        userName?: string,
        birthDate?: string,
        phoneNumber?: string,
        introduction?: any,
    }) => {
        const result = await this.api.post({
            path: `${Constants.ApiPath.PROFILE.UPDATE_PROFILE}`,
            data: data,
        });
        return result.data.result;
    };

    public updateOrganizationProfile = async (data: {
        id?: string,
        userId?: string,
        userType?: number,
        email?: string,
        gender?: number,
        lastName?: string,
        firstName?: string,
        dateOfBirth?: any,
        phoneNumber?: string,
        employmentDate?: any,
        idCardNo?: string,
        idCardIssuedDate?: any,
        idCardIssuedPlace?: string,
        socialInsuranceCode?: string,
        passportNo?: string,
        passportExpiredDate?: any,
        passportIssuedPlace?: string,
        nationality?: string,
        possessionKey?: string,
        organizationId?: string,
        extraInformation?: { description?: string },
        groupUserTitles?: {
            groupId: string,
            userTitle: string
        }[]
    }[]) => {
        const result = await this.api.post({
            path: `${Constants.ApiPath.PROFILE.UPDATE_ORGANIZATION_PROFILE}`,
            data,
        });
        return result.data.result;
    };

    public changePassword = async (data: {
        oldPassword?: string,
        newPassword?: string,
        confirmPassword?: string,
    }) => {
        const result = await this.api.post({
            path: `${Constants.ApiPath.PROFILE.CHANGE_PASSWORD}`,
            data,
        });
        return result.data.result;
    };

    public updateAvatar = async (data: {
        avatarId?: string,
        avatarUrl?: string
    }) => {
        const result = await this.api.post({
            path: `${Constants.ApiPath.PROFILE.UPDATE_AVATAR}`,
            data,
        });
        return result.data.result;
    };

}

export default ProfileService;
